import React, { Component } from 'react'
import { connect } from 'react-redux'
import AppSidebarComponent from './templates/sidebar'
import {Route, withRouter} from 'react-router-dom'

import AppBaseComponent from './templates/base'
import AppContentComponent from './templates/content'
import OverlayComponent from './templates/overlay'
import AppHomeComponent from './components/home'
import AppPromotionsComponent from './components/promotions'
import AppCampaignsComponent from './components/campaigns'
import AppStatisticsComponent from './components/statistics'

import AppSettingsComponent from './components/settings'
import * as serviceWorker from "../serviceWorker";

class AppComponent extends Component {
	constructor(props) {
		super(props);

		this.state = {
			newVersionAvailable: false,
			waitingWorker: {}
		}
	}

	componentWillReceiveProps( nextProps ) {
		if ( false === nextProps.auth.isAuthenticated ) {
			this.props.history.push('/login' );
		}
	}

	componentDidMount() {
		const {newVersionAvailable} = this.state;

		serviceWorker.register({onUpdate: this.onServiceWorkerUpdate});
	}

	onServiceWorkerUpdate = (registration) => {
		console.log('New Version');
		this.setState({
			waitingWorker: registration && registration.waiting,
			newVersionAvailable: true,
		});
	};

	updateServiceWorker = () => {
		const {waitingWorker} = this.state;
		waitingWorker && waitingWorker.postMessage({type: "SKIP_WAITING"});
		this.setState({newVersionAvailable: false});
		window.location.reload();
	};


	render() {

		const updateModalClasses = [
			'update-modal'
		];

		if (this.state.newVersionAvailable) {
			updateModalClasses.push('update-modal--visible');
		}

		return (
			<AppBaseComponent>
				<AppSidebarComponent/>
				<AppContentComponent>
					<Route exact path="/app" component={ AppHomeComponent } />
					<Route path="/app/promotions" component={ AppPromotionsComponent } />
					<Route path="/app/campaigns" component={ AppCampaignsComponent } />
					<Route path="/app/stats" component={ AppStatisticsComponent } />
					<Route path="/app/settings" component={ AppSettingsComponent } />
				</AppContentComponent>
				<OverlayComponent />


				<div className={updateModalClasses.join(' ')}>
					<div className="grid-container">
						<div className="grid-x grid-margin-x grid-margin-y grid-padding-y">
							<div className="cell">
								<div className="update-modal--inner" onClick={this.updateServiceWorker}>
									Er is een update beschikbaar. Klik om te updaten.
								</div>
							</div>
						</div>
					</div>
				</div>

			</AppBaseComponent>
		);
	}
}

const mapStateToProps = ( state ) => {
	return {
		auth: state.auth,
		user: state.auth.user
	};
};

export default withRouter(connect(mapStateToProps)(AppComponent));


// WEBPACK FOOTER //
// ./src/application/index.js